<template>
  <div class="p-quick-links" v-click-outside="{ handler: closeQuickLinks }">
    <button
      class="p-quick-links__tab"
      type="button"
      :aria-expanded="quickLinksOpen.toString()"
      aria-controls="portal-quick-links"
      @click="toggleQuickLinks"
    >
      <v-icon size="20">mdi-link-variant</v-icon>
      <span>Quick Links</span>
    </button>

    <div
      v-if="quickLinksOpen"
      id="portal-quick-links"
      class="p-quick-links__panel"
    >
      <button
        v-for="link in links"
        :key="link.routeName"
        class="p-quick-links__item"
        type="button"
        @click="goToQuickLink(link.routeName)"
      >
        <v-icon size="20">{{ link.icon }}</v-icon>
        <span>{{ link.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickLinks',

  props: {
    links: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    quickLinksOpen: false
  }),

  methods: {
    toggleQuickLinks() {
      this.quickLinksOpen = !this.quickLinksOpen
    },

    closeQuickLinks() {
      this.quickLinksOpen = false
    },

    handleKeydown(event) {
      if (event.key === 'Escape') this.closeQuickLinks()
    },

    goToQuickLink(routeName) {
      this.closeQuickLinks()
      this.$router.push({ name: routeName })
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style lang="scss" scoped>
.p-quick-links {
  position: fixed;
  top: 215px;
  left: 0;
  z-index: 6;
  display: flex;
  align-items: flex-start;
}

.p-quick-links__tab {
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 6px;
  padding: 9px 11px;
  border: 0;
  border-radius: 0 22px 22px 0;
  color: white;
  background: $primary-color;
  box-shadow:
    0 0 0 1px rgba(229, 243, 255, 0.95),
    0 0 16px rgba(0, 137, 199, 0.32);
  cursor: pointer;
  writing-mode: vertical-rl;
}

.p-quick-links__tab span {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0;
  text-transform: uppercase;
}

.p-quick-links__panel {
  width: 220px;
  margin-left: 8px;
  padding: 8px;
  border: 1px solid rgba(0, 137, 199, 0.22);
  border-radius: 16px;
  background: white;
  box-shadow:
    0 0 0 1px rgba(229, 243, 255, 0.8),
    0 10px 28px rgba(0, 137, 199, 0.22);
}

.p-quick-links__item {
  display: flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 0;
  border-radius: 18px;
  color: #333;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
}

.p-quick-links__item:hover,
.p-quick-links__item:focus {
  background: #f2f5fb;
  outline: none;
}

.p-quick-links__item .v-icon {
  color: $primary-color;
}
</style>
